


































































































import { Vue, Component, Mixins } from "vue-property-decorator";

import MyForm from "@/mixins/form";

import OperationHistory from "@/components/operationhistory.vue";

import Stadiums from "./stadiums.vue";

@Component({
  components: {
    Stadiums,
    OperationHistory
  }
})
export default class extends Mixins(MyForm) {
  columns: any[] = [
    { title: "序号" },
    { title: "变更日期" },
    { title: "变更项目" },
    { title: "变更前" },
    { title: "变更后" }
  ];

  adminData: any = {
    username: "",
    mobile: ""
  };

  adminForm!: any;

  beforeCreate() {
    this.adminForm = this.$form.createForm(this, {});
  }

  handleSubmit(e: any) {
    e.preventDefault();
    this.form.validateFields((err: any, values: any) => {
      if (!err) {
        this.$confirm({
          title: "确认信息",
          content: "确定要提交吗？",
          onOk: async () => {
            this.confirmLoading = true;
            const res = await this.$store.dispatch("customer/edit", {
              id: this.editId,
              ...values
            });
            if (res && res.Message && res.Message === "success") {
              this.$message.success(res.Message);
              this.handleCancel();
            } else {
              this.$message.error(res.Message);
            }
            this.confirmLoading = false;
          }
        });
      }
    });
  }

  handleSubmitAdmin(e: any) {
    e.preventDefault();
    this.adminForm.validateFields((err: any, values: any) => {
      if (!err) {
        this.$confirm({
          title: "确认信息",
          content: "确定要提交吗？",
          onOk: async () => {
            this.confirmLoading = true;
            const res = await this.$store.dispatch("customer/editadmin", {
              customer_id: this.editId,
              ...values
            });
            if (res && res.Message && res.Message === "success") {
              this.$message.success(res.Message);
            } else {
              this.$message.error(res.Message);
            }
            this.confirmLoading = false;
          }
        });
      }
    });
  }

  async mounted() {
    this.spinLoading = true;
    const res = await this.$store.dispatch("customer/detail", {
      id: this.editId
    });
    if (res && res.Data) {
      this.formData = res.Data;
    }

    const res1 = await this.$store.dispatch("customer/admin", {
      customer_id: this.editId
    });
    if (res1 && res1.Data) {
      this.adminData = res1.Data;
    }
    this.spinLoading = false;
  }
}
